import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

// Configuración base de axios para la API
export const apiClient = axios.create({
  baseURL: "/api", // Usar proxy de Vite en desarrollo, directo en producción
  timeout: 600000, // 10 minutos para operaciones de migración de producción
  headers: {
    "Content-Type": "application/json",
  },
});

// Función auxiliar para obtener token de autenticación
const getAuthToken = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();

    // Priorizar idToken que contiene información completa del usuario
    const idToken = session.tokens?.idToken?.toString();
    if (idToken) {
      return idToken;
    }

    // Fallback a accessToken si idToken no está disponible
    const accessToken = session.tokens?.accessToken?.toString();
    if (accessToken) {
      return accessToken;
    }

    return null;
  } catch (error) {
    console.warn("Error obteniendo token de autenticación:", error);
    return null;
  }
};

// Interceptor para agregar automáticamente el token JWT a todas las peticiones
apiClient.interceptors.request.use(
  async (config: any) => {
    const token = await getAuthToken();

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      console.warn("No se encontró token de autenticación disponible");
    }

    return config;
  },
  (error: any) => {
    console.error("Error en interceptor de request:", error);
    return Promise.reject(error);
  },
);

// Interceptor para manejar errores de respuesta
apiClient.interceptors.response.use(
  (response) => response,
  async (error: any) => {
    if (error.response?.status === 401) {
      console.warn("Token de autenticación inválido o expirado");
      // Aquí podrías redirigir al login si es necesario
    }

    return Promise.reject(error);
  },
);
